import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus, { ElMessage } from 'element-plus';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import '@/styles/theme.css';
import { initTheme } from '@/lib/theme';
import { rootStore } from '@/store/rootStore';
import { getStore } from '@/lib/localStore';
import { Tree } from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { createPinia } from 'pinia';
import i18n from '@/i18n';
import { newRouter } from '@/router';
import initRouter from '@/router/hook';
import request from '@/lib/request';
import errReport from '@/lib/errReport';
import 'core-js/actual/array/flat-map';
import { bigDataInit } from '@/lib/bigDataTrack';
import { migrateHomeVersion } from '@/lib/version';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);

initTheme();
const setting = getStore({ name: 'systemSetting' });
if (setting?.darkMode !== undefined) {
  rootStore().setSystemSetting('darkMode', setting.darkMode);
}
if (setting?.homeViewMode === 'list' || setting?.homeViewMode === 'card') {
  rootStore().setSystemSetting('homeViewMode', setting.homeViewMode);
}
if (setting?.homeOpenTarget === 'newTab' || setting?.homeOpenTarget === 'sameTab') {
  rootStore().setSystemSetting('homeOpenTarget', setting.homeOpenTarget);
}

app.use(Tree);
app.config.globalProperties.$http = request;
app.config.globalProperties.$message = ElMessage;
app.config.errorHandler = (err, vm) => {
  let { message, name, stack } = err;
  if (message || name) {
    errReport(`组件：${vm?.$options?.__name}`, stack ? stack.toString() : `${name}:${message}`);
  }
  console.error(err);
};

const isLocal = /localhost|127\.0.0.1/i.test(location.hostname);
// isLocal &&
//   localStorage.setItem(
//     'LINGHIT_UNIFY_BACKEND_TOKEN_V2',
//     JSON.stringify({
//       value:
//         '66398f7b4d43cc315e44ec36457899adeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVSUQiOjE2MDgzNzUzMzQwMDAwMDA5MCwiU2NvcGUiOiJsb2dpbiIsIkV4cGFuZCI6eyJjaGFyYWN0ZXJpc3RpYyI6ImE2YmY5NGJkYjg4ZTEzNGZkNTIwMTE3MmUwMGQ2NTQ3IiwiaXAiOjI4ODY3ODY1NjF9LCJleHAiOjE3Nzg4NjA3OTksImlhdCI6MTc3ODgzODEwMn0.oezipAn0BeC4-tBnmMuRe8t8RMXZxl4KVpP9O2MYGKI',
//       expiry: 1778888502629,
//       create: 1778838102629,
//     })
//   );

migrateHomeVersion();

const router = newRouter();
initRouter(router);
app.use(router);
app.use(i18n);
app.config.globalProperties.$t = i18n.global.t;

app.use(ElementPlus);
bigDataInit();
app.mount('#app');
